module.exports = __webpack_public_path__ + "img/insurance.78347aa.svg";